import { useProductStore } from "./useProductStore";

export const useCurrentConfigs = () => useProductStore((state) => state.policy);
